// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__77-AA","index":"styles_index__36lBc"};